export interface ErrorLayoutProps {
  children: React.ReactNode
}

export const ErrorLayout = ({ children }: ErrorLayoutProps) => {
  return (
    <div className="grid min-h-svh content-start items-start justify-items-center gap-8 bg-brand-secondary-bright pb-[5%] pt-[5%]">
      <div className="w-full max-w-lg rounded-md bg-white p-8 shadow-sm">{children}</div>
    </div>
  )
}

ErrorLayout.displayName = 'ErrorLayout'
